import React, { Component } from 'react'
import {
    Nav,
    Container,
} from "react-bootstrap";
import { ReactComponent as InstagramIcon } from "Assets/icons/instagram.svg";
import { ReactComponent as TelegramIcon } from "Assets/icons/telegram.svg";
import { ReactComponent as XIcon } from "Assets/icons/x.svg";
import { ReactComponent as LinkedinIcon } from "Assets/icons/linkedin.svg";
import { ReactComponent as AparatIcon } from "Assets/icons/aparat.svg";
import { ReactComponent as YoutubeIcon } from "Assets/icons/youtube.svg";
import LogoImg from "Assets/Images/LogoGray.svg";
import { useTranslation } from "react-i18next";
const Footer = () => {
    const { t, i18n } = useTranslation();
    const currentLang = i18n.language; // Get the current language
        return (
            <footer>
                <div className="footer-bg">
                    <div className="container-fluid">
                        <div className="footer-top py-5">
                            <div className="row py-3">
                                <div className="col-7">
                                    <div className="footer-logo flex-grow-1 position-relative">
                                        <img src={LogoImg} />
                                    </div>
                                    <div className="footer-about">
                                        {t('energyExchangeHistory')}
                                    </div>
                                </div>
                               
                                <div className="col-2">
                                    <div className="footer-menu text-capitalize">
                                        <h4 className="head-with-line"><span>{t('useful_links')}</span></h4>
                                        <ul className="footer-links list-unstyled mb-0 ee-list mt-4">
                                            
                                            <li><a href="/Media/Multimedia">{t('media')}</a></li>
                                            <li><a href="/LegalLiteracy">{t('legal_literacy')}</a></li>
                                            
                                            <li><a href="/Forms">{t('forms')}</a></li>
                                            <li><a href="/Market/Brokers">{t('registered_brokers')}</a></li>
                                            {currentLang === 'fa' && (
                                                <li><a href="/Announcements">{t('public_notices')}</a></li>
                                            )}
                                            <li><a href="/MarketExpansion/ResearchReportsList">{t('research_reports')}</a></li>
                                            <li><a href="/Encyclopedia">{t('encyclopedia')}</a></li>
                                            {/*<li><a href="/ContactUs">{t('contact_us')}</a></li>*/}
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-3">
                                    <div className="footer-menu">
                                        <h4 className="head-with-line"><span>{t('other_links')}</span></h4>
                                        <div className="d-flex flex-xs-nowrap flex-sm-wrap flex-md-wrap flex-lg-nowrap">
                                            <ul className="footer-links list-unstyled mb-0 ee-list mt-4">
                                                <li><a href="https://president.ir/fa/nahad" target="_blank">{t('presidencyOffice')}</a></li>                                                
                                                <li><a href="https://www.mop.ir/" target="_blank">{t('mop')}</a></li>
                                                <li><a href="https://moe.gov.ir/" target="_blank">{t('moe')}</a></li>
                                                <li><a href="https://www.seo.ir/" target="_blank">{ t('seo')}</a></li>
                                                <li><a href="https://www.csdiran.ir/" target="_blank">{t('csdiran')}</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="copyright pt-1 d-flex align-items-md-between align-items-center flex-wrap flex-md-nowrap flex-row-reverse flex-md-row">
                            <div className="flex-grow-1 text-right">{t('copyright')}</div>
                            <Nav className="footer-social list-unstyled d-flex gap-2 mb-0 flex-grow-1 flex-sm-0 justify-content-end">
                                <Nav.Item>
                                    <Nav.Link href="https://instagram.com/ieemedia" target="_blank"><InstagramIcon /></Nav.Link>
                                </Nav.Item>

                                <Nav.Item>
                                    <Nav.Link href="https://t.me/ieemedia" target="_blank"><TelegramIcon /></Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link href="https://twitter.com/ieemedia" target="_blank">
                                        <XIcon />
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link href="https://aparat.com/ieemedia" target="_blank">
                                        <AparatIcon />
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link href="https://linkedin.com/company/irenex" target="_blank"><LinkedinIcon /></Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link href="https://youtube.com/@ieemedia" target="_blank"><YoutubeIcon /></Nav.Link>
                                </Nav.Item>
                            </Nav>
                        </div>
                    </div>
                </div>
                

            </footer>
        )
}

export default Footer;